import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Skeleton } from '@/components/ui/skeleton'
import { AdminUserDetailView } from '@/containers/AdminUsers/AdminUserDetail'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { AdminUser } from '@/types/User'

export default function AdminUserDetailPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'admin.users',
  })

  const { data: user, isLoading } = useSWR<AdminUser>(
    `/api/v2/admin/users/${id}`,
    apiFetcher,
  )

  const title = user?.fullName || user?.email || t('detail.title')

  useSetPageHeader({
    breadcrumbs: [
      { href: '/admin/users', children: t('title') },
      { href: `/admin/users/${id}`, children: title },
    ],
  })

  return (
    <>
      <title>{title}</title>

      <div className="mx-auto w-full max-w-[1280px]">
        {isLoading && (
          <div className="space-y-6">
            <Skeleton className="h-8 w-64" />
            <div className="grid gap-8 lg:grid-cols-[320px_1fr]">
              <Skeleton className="h-64 rounded-lg" />
              <Skeleton className="h-64 rounded-lg" />
            </div>
          </div>
        )}

        {user && <AdminUserDetailView user={user} />}
      </div>
    </>
  )
}
